<template>
	<div class="supervisorRank pdr0 tradarHeight">
		<div class="rankTopLeft">
			<svg-icon class="fz18 marr4" icon-class='vispersonalability'></svg-icon>
			<div class="inlin">
				<span class="marr4 fz14">{{title}}</span>
			</div>
		</div>
		<div>
			<el-row class="mart12">
				<el-col :span="15" ref="breadcrumb" class="border_right__mako">
					<div :id="radarCharts" ref="radarCharts" class="radarCharts"></div>
				</el-col>
				<el-col :span="9" :id="rightWidth" class="postr center" :style="{height:height+'px'}">
					<canvas :id="dashboardCanvas" :height="height-100" :style="{width:width+'px',position:'relative',top:'23px'}"></canvas>
					<svg-icon class="marr4 liquidFillCharts" :icon-class='icon'></svg-icon>
					<div class="fz14 center text percentText colwhite">
						<span v-if="percent==0" class="fz14">
							还需要继续努力哦！
						</span>
						<span v-else>
							已超过<span class="fz26">{{percent}}%</span>的{{suffix}}
						</span>
					</div>
				</el-col>
			</el-row>
			<el-row class="marl5">
				<div class="explain fz13 mart12 colwhite">
					<div>{{textexplain.Catogary}} : {{textexplain.Description}}</div>
				</div>
			</el-row>
		</div>
	</div>
</template>

<script>
	// import Api from '../../api'
	// import { mapState, mapActions, mapMutations} from 'vuex'
	import echarts from 'echarts';
	export default {
		props:['percent','title','suffix','colorList','dataList','icon','legendData'],
		data() {
			return {
				myChart: null,
				width: null,
				height:null,
				textexplain:{},
			}
		},
		computed: {
			...Vuex.mapState('supervisor', ['breadcrumbList', 'GetReportListArr']),
			...Vuex.mapState('visualization', ['trigger', 'setDateArr','hospitalCountLists']),
			triggers() {
				return this.trigger.tradarFlag;
			},
			dashboardCanvas() {
				return 'dashboardCanvas' + parseInt(Math.random() * 100);
			},
			rightWidth(){
				return 'rightWidth' + parseInt(Math.random() * 100);
			},
			radarCharts(){
				return 'radarCharts' + parseInt(Math.random() * 100);
			}
		},
		watch: {
			dataList(old) {
				if (this.dataList) {
					this.GetReportListArr.toCanvasFlag = true;
					this.$nextTick(() => {
						this.initTradar();
					})
				}
			},
			percent(){
				 this.toCanvas(this.dashboardCanvas, this.colorList[1], this.percent);
			}
		},
		updated() {
			if (this.trigger.tradarFlag) {
				this.$nextTick(() => {
					this.initTradar();
				})
			}
		},
		mounted() {
			let _this = this;
			this.erd.listenTo(document.getElementsByClassName("el-main"), function(element) {
				if (document.getElementById(_this.rightWidth)) {
					_this.width = document.getElementById(_this.rightWidth).offsetWidth;
					_this.width = document.body.clientWidth >= 1440 ? document.getElementById(_this.rightWidth).offsetWidth : document.getElementById(_this.rightWidth).offsetWidth-80;
					_this.height = _this.$refs.radarCharts.offsetHeight;
					_this.$nextTick(() => {
						_this.toCanvas(_this.dashboardCanvas, _this.colorList[1] , _this.percent);
						_this.initTradar();
					})
				}
			})
		},
		methods: {
			...Vuex.mapMutations('breadcrumb', ['setTootipType', 'clearRow']),
			...Vuex.mapMutations('supervisor', ['setBreadcrumbList']),
			initTradar() {
				this.trigger.tradarFlag = false;
				this.getradarCharts();
				if (this.dataList.Current&&this.dataList.Current.length>=1) {
					 this.textexplain  =  this.dataList.Current[0];
				}
			},
			getradarCharts() {
				let dom = document.getElementById(this.radarCharts);
				this.myChart = echarts.init(dom);
				let data = [];
				let value = [];
				let valuecurrent = [];
				let color = this.colorList;
				let legendData = this.legendData;
				if (this.dataList.Current&&this.dataList.Current.length > 0) {
					this.dataList.Current.forEach(element => {
						data.unshift({
							name: element.Catogary,
							max: element.TotalScore
						})
						value.unshift(element.Score)
					})
					this.dataList.Total.forEach(element => {
						valuecurrent.unshift(element.Score)
					})
				} else {
					data = [];
					value = [];
					valuecurrent = [];
				}
				let option = null;
				option = {
					tooltip: {},
					legend: {
						data: legendData,
						textStyle: {
							fontSize: this.fontSize(0.12),
							color: '#ffffff'
						},
						itemHeight: this.fontSize(0.1),
						itemWidth: this.fontSize(0.1),
						bottom: - this.fontSize(0.05),
						x: 'left'
					},
					radar: {
						name:{
							textStyle: {
								color: '#fff',
								fontSize: this.fontSize(0.12),
							},
						    formatter:function(v){
						        return v;
						    }
						},
						triggerEvent:true,
						startAngle: 162,
						indicator: data,
						splitLine: {
							lineStyle: {
								color: ['#3C4048']
							}
						},
						splitArea: {
							areaStyle: {
								color: ['#32353d'],
								shadowColor: '#32353d',
								shadowBlur: 20
							}
						},
						axisLine: {
							lineStyle: {
								color: '#3C4048'
							}
						},
						// radius: this.fontSize(1.2),
						// center: ['50%', '50%'],
					},
					series: [{
						name: '能力刻画',
						type: 'radar',
						symbol: 'none',
						data: [{
							value: valuecurrent,
							name: legendData[0],
							// areaStyle: {
							// 	opacity: .1
							// },
							itemStyle: {
								color: color[0]
							},
							lineStyle: {
								normal: {
									width: 2,
									opacity: 1
								}
							},
							list:data
						}, {
							value: value,
							name: legendData[1],
							areaStyle: {
								opacity: .3
							},
							itemStyle: {
								color: color[1]
							},
							lineStyle: {
								normal: {
									width: 1,
									opacity: 1
								}
							},
							list:data
						}]
					}]
				};
				if (option && typeof option === "object") {
					this.myChart.clear()
					this.myChart.setOption(option, true);
					this.myChart.off('click'); //清除联系点击
					this.myChart.on('click', (params) => {
						this.dataList.Current.forEach(item=>{
							if(params.name == item.Catogary){
								this.textexplain = item;
							}
						})
					});
					this.myChart.resize(); //区域更新
					window.addEventListener("resize", () => {
						this.myChart.resize();
					});
				}
			},
		}
	}
</script>

<style scoped>
.supervisorPages .supervisorRank{
	padding-right: 0;
}
</style>
